{
  "title": "Presyo sa palengke",
  "lead": "Mga umiiral na presyo ng gulay at iba pang ani, sinusuri araw-araw ng Municipal Agriculture Office.",
  "emptyTitle": "Wala pang nakalathalang presyo",
  "emptyBody": "Ilalathala rito ng Agriculture Office ang presyo araw-araw. Bumalik po mamaya.",
  "noPricesTitle": "Wala pang naitalang presyo",
  "noPricesBody": "Lalabas dito ang presyo sa palengkeng ito kapag naitala na ng Agriculture Office.",
  "market": "Palengke",
  "group": "Grupo",
  "allGroups": "Lahat",
  "atMarket": "Presyo sa {market}",
  "asOf": "noong {date}",
  "noPriceYet": "Wala pang presyo",
  "perUnit": "{price} bawat {unit}",
  "perUnitLabel": "bawat {unit}",
  "range": "{low} hanggang {high}",
  "up": "Tumaas nang {pct}% mula {date}",
  "down": "Bumaba nang {pct}% mula {date}",
  "unchanged": "Walang pagbabago mula {date}",
  "openTrendFor": "{name}: tingnan ang galaw ng presyo",
  "note": "Ito ang presyong hinihingi ng karamihan ng nagtitinda sa araw na iyon. Gabay lamang ito, hindi takdang presyo.",
  "period": "Panahon",
  "lastDays": "Huling {days} araw",
  "showTable": "Ipakita bilang talaan",
  "showChart": "Ipakita bilang tsart",
  "trendTitle": "{name}, huling {days} araw",
  "noTrend": "Walang presyo sa panahong ito.",
  "prevailing": "Umiiral",
  "low": "Pinakamababa",
  "high": "Pinakamataas",
  "trendSummary": "Umiiral na presyo ng {name} sa huling {days} araw: {first} noong {firstDate}, ngayon {last} noong {lastDate}. Pinakamababa {low}, pinakamataas {high}.",
  "chartKeysHint": "Gamitin ang kaliwa at kanang arrow key para basahin ang presyo bawat araw.",
  "adminTitle": "Presyo sa palengke",
  "adminLead": "Itala ang presyo ngayong araw, ayusin ang listahan ng paninda at palengke, at i-download ang kasaysayan.",
  "tabPrices": "Presyo araw-araw",
  "tabCommodities": "Mga paninda",
  "tabMarkets": "Mga palengke",
  "tabExport": "I-export",
  "setupTitle": "Ihanda muna ang talaan ng presyo",
  "setupBody": "Magdagdag ng kahit isang palengke at isang paninda. Pagkatapos, makakapagtala na kayo ng presyo araw-araw.",
  "addMarket": "Magdagdag ng palengke",
  "addCommodity": "Magdagdag ng paninda",
  "copyAllEmpty": "Kopyahin ang huling tala sa mga bakanteng hanay",
  "copyLast": "Kopyahin ang huli",
  "copyLastFor": "Kopyahin ang huling tala para sa {name}",
  "gridHint": "Presyo sa {market}, sa piso. Ang umiiral na presyo lang ang kailangan. Burahin ang umiiral na presyo para alisin ang tala sa araw na iyon.",
  "lastEntry": "Huling tala: {price} noong {date}",
  "noLastEntry": "Walang naunang tala",
  "corrected": "Itinama nang {count}×",
  "prevailingPeso": "Umiiral (₱)",
  "lowPeso": "Pinakamababa (₱)",
  "highPeso": "Pinakamataas (₱)",
  "noteLabel": "Tala",
  "unsaved": "{count} hanay ang binago",
  "noChanges": "Wala pang pagbabago",
  "savePrices": "I-save ang presyo",
  "savedToast": "Na-save ang {count} presyo.",
  "fixRows": "Ayusin muna ang mga hanay na may markang pula.",
  "errNumber": "Ilagay ang halaga gaya ng 28 o 28.50.",
  "errPrevailing": "Ilagay din ang umiiral na presyo.",
  "errLow": "Mas mataas ang pinakamababang presyo kaysa sa umiiral.",
  "errHigh": "Mas mababa ang pinakamataas na presyo kaysa sa umiiral.",
  "historyTitle": "Mga pagtatama: {name}",
  "historyBefore": "Dati: {price}",
  "historyChanged": "Binago noong {date} ni {name}",
  "addFromCrops": "Idagdag ang mga pananim mula sa listahan ng LGU",
  "cropsAdded": "Nagdagdag ng {count} paninda mula sa listahan ng pananim.",
  "cropsNone": "Nasa listahan na ang lahat ng pananim.",
  "noCommoditiesTitle": "Wala pang paninda",
  "noCommoditiesBody": "Idagdag ang mga gulay at iba pang ani na sinusubaybayan ninyo ang presyo.",
  "hidden": "Nakatago",
  "editName": "I-edit ang {name}",
  "moveUp": "Itaas ang {name}",
  "moveDown": "Ibaba ang {name}",
  "editCommodity": "I-edit ang paninda",
  "commodityName": "Paninda",
  "commodityNameHint": "Halimbawa: Repolyo (scorpio).",
  "unit": "Yunit",
  "unitHint": "Halimbawa: kg, tali, piraso.",
  "groupHint": "Opsyonal na pamagat sa pampublikong pahina, halimbawa: Gulay sa kabundukan.",
  "showPublicly": "Ipakita sa pampublikong talaan ng presyo",
  "marketsLead": "Kung saan sinusuri ang presyo, halimbawa ang vegetable trading post.",
  "noMarketsTitle": "Wala pang palengke",
  "noMarketsBody": "Idagdag ang palengke kung saan sinusuri ng inyong opisina ang presyo.",
  "editMarket": "I-edit ang palengke",
  "marketName": "Pangalan ng palengke",
  "marketNameHint": "Halimbawa: Vegetable Trading Post.",
  "location": "Lokasyon",
  "exportTitle": "I-download ang kasaysayan ng presyo",
  "exportLead": "Isang spreadsheet (CSV) ng bawat presyong itinala ng inyong opisina sa pagitan ng dalawang petsa.",
  "downloadCsv": "I-download ang CSV"
}
